import {useIsMutating, useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { addOutCome, getOutcomes, updatOutCome } from "./OutcomeRepo"
import { toast } from "react-toastify"
import { showToast } from "../../../utils/toastUtils"

interface paramsInterface{
page:number,
limit:number,
search:string
}

export const useGetOutcomesList =({enable=false,params}:{enable:boolean,params:paramsInterface})=>{
  
    return useQuery({
        queryKey:['GET_OUTCOME_LITS',params],
        queryFn:()=>getOutcomes(params),
        retry:false,
        enabled:enable
    })
}

interface ReqBody {
  Type: string,
  Reason: string,
  OutletTypeId: number
}
export const useAddOutComes=()=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn:(ReqBody:ReqBody)=>addOutCome(ReqBody),
        onSuccess:()=>{
         showToast.success('Outcome Added Successfully');
        queryClient.invalidateQueries({queryKey:['GET_OUTCOME_LITS']})
        },
        onError:(error:any)=>{
           showToast.error('Failed to add OutCome')
           toast.error('Failed to add Outcome',error.message);
        }
    })
}



export const useUpdateOutcome =()=>{
    
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn:({ReqBody,id} : {ReqBody:ReqBody,id:number})=>updatOutCome(ReqBody,id),
        onSuccess:()=>{
         showToast.success('Updated Successfully');
            queryClient.invalidateQueries({queryKey:['GET_OUTCOME_LITS']});
        },
        onError:(error:any)=>{
         showToast.error("Failed to Update Outcome");
         toast.error('Failed to Update',error.message);
        }
    })
} 